import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'

import { PrimaryButton } from 'Components/Shared/Button'

type Props = {
  onClickAccept: () => void
  isLoading?: boolean
}

const CmAcceptMcTaskFooter: React.FC<Props> = ({
  onClickAccept,
  isLoading = false,
}) => {
  return (
    <FooterContent>
      <Row type="flex" justify="end" align="middle">
        <Col>
          <div className="btn-submit">
            <PrimaryButton
              text="รับงาน"
              disabled={isLoading}
              onClick={onClickAccept}
            />
          </div>
        </Col>
      </Row>
    </FooterContent>
  )
}

const FooterContent = styled.div`
  max-width: 1110px;
  margin: 0 auto;
  color: #000;
  font-size: 20px;
  padding-right: 20px;

  .btn-submit {
    width: 191px;
    text-align: right;
    button {
      border-radius: 5px;
      width: 191px;
      height: 48px;
      font-size: 20px;
    }
  }
`

export default CmAcceptMcTaskFooter
